<template>
	<div class="order">
		<div class="tabdiv">
			<el-tabs v-model="activeName">
				<el-tab-pane :label="v.label" :name="v.name" v-for="(v,k) in tablist" :key="k">
					<div slot="label">
						<span>{{v.label}}</span>
						<span class="red" v-if="v.num>0">({{v.num}})</span>
					</div>
				</el-tab-pane>
			</el-tabs>
		</div>
		<div class="btnbox">
			<el-button type="primary" size="small" v-if="btnshow === 0" @click="onpayAll()">批量付款</el-button>
			<el-button type="primary" size="small" v-if="btnshow === 0" @click="ondeleteAll()">批量删除</el-button>
			<el-button type="primary" size="small" @click="onimport()">订单批量导入</el-button>
			<el-button type="primary" size="small" @click="onexport()">订单列表导出</el-button>
		</div>

		<div class="tablebox">
			<div class="filterdiv filterty" ref="filter">
				<el-form :inline="true" :model="formfilter" class="demo-form-inline" size="small" label-width="0"
					v-if="filtershow">
					<el-form-item label="">
						<el-select v-model="formfilter.date_type" placeholder="时间类型">
							<el-option label="时间类型" value=""></el-option>
							<el-option :label="v.name" :value="v.id" v-for="(v,k) in appdata.list.order_date_type"
								:key="k">
							</el-option>
						</el-select>
						<el-date-picker v-model="formfilter.mydate" type="daterange" range-separator="至"
							start-placeholder="开始日期" end-placeholder="结束日期" format="yyyy-MM-dd"
							value-format="yyyy-MM-dd">
						</el-date-picker>
					</el-form-item>
					<el-form-item label="">
						<el-input v-model="formfilter.brand" placeholder="品牌"></el-input>
					</el-form-item>
					<el-form-item label="">
						<el-input v-model="formfilter.shop_name" placeholder="渠道"></el-input>
					</el-form-item>
					<el-form-item label="">
						<el-select v-model="formfilter.delivery_id" placeholder="实发快递" filterable size="small">
							<el-option label="实发快递" value=""></el-option>
							<el-option :label="v.name" :value="v.id" v-for="(v,k) in appdata.list.delivery" :key="k">
							</el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="">
						<el-input v-model="formfilter.trade_no" placeholder="订单号"></el-input>
					</el-form-item>
					<el-form-item label="" v-if="activeName == 'qb'">
						<el-select v-model="formfilter.cfrom" placeholder="订单来源">
							<el-option label="订单来源" value=""></el-option>
							<el-option :label="v.name" :value="v.id" v-for="(v,k) in appdata.list.order_cfrom" :key="k">
							</el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="">
						<el-select v-model="formfilter.order_status" placeholder="订单状态">
							<el-option label="订单状态" value=""></el-option>
							<el-option :label="v.name" :value="v.id" v-for="(v,k) in appdata.list.order_status"
								:key="k">
							</el-option>
						</el-select>
					</el-form-item>

					<el-form-item label="">
						<el-input v-model="formfilter.recv_name" placeholder="收件人"></el-input>
					</el-form-item>


					<el-form-item label="">
						<el-input v-model="formfilter.delivery_num" placeholder="快递单号"></el-input>
					</el-form-item>

					<el-form-item label="">
						<el-input v-model="formfilter.out_trade_no" placeholder="客户单号"></el-input>
					</el-form-item>

					<el-form-item label="">
						<el-input v-model="formfilter.recv_mobbile" placeholder="手机号"></el-input>
					</el-form-item>

					<el-form-item label="">
						<el-input v-model="formfilter.style_number" placeholder="款号"></el-input>
					</el-form-item>

					<el-form-item label="">
						<el-select v-model="formfilter.buyer_mark" placeholder="标记">
							<el-option label="标记" value=""></el-option>
							<el-option :label="v.name" :value="v.id" v-for="(v,k) in appdata.list.mark" :key="k">
							</el-option>
						</el-select>
					</el-form-item>

					<el-form-item label="">
						<el-input v-model="formfilter.buyer_remark" placeholder="备注"></el-input>
					</el-form-item>
					<el-form-item label="">
						<el-input v-model="formfilter.buyer_memo" placeholder="备忘"></el-input>
					</el-form-item>

					<el-form-item>
						<el-button type="primary" @click="onfilter">查询</el-button>
						<el-button @click="onreset">重置</el-button>
					</el-form-item>
				</el-form>
			</div>
			<div class="zk" @click="filtershow=!filtershow ">
				<span>{{filtershow ? '收起':'展开'}}</span>
			</div>
			<div class="tablediv tablediv-compact" ref="tablediv">
				<el-table :data="list" style="width: 100%" border height="100%" :cell-class-name="cellClassName" @selection-change="handleSelectionChange">
					<el-table-column type="selection" width="40" align="center" header-align="center" fixed="left"/>
					<el-table-column prop="order_status_str" label="状态" align="center" header-align="center"
						min-width="70px" fixed="left">
					</el-table-column>
					<el-table-column label="订单编号" align="center" header-align="center" min-width="140px">
						<template slot-scope="scope">
							<div @click="oncopy(scope.row.trade_no)">{{scope.row.trade_no}}</div>
							<div
								v-if="scope.row.order_status == 3 && scope.row.apply_cancel == 1 && scope.row.agree_send == 0">
								<div class="red">申请取消{{ scope.row.is_auto_cancel == 1 ? '（系统）' : '' }}</div>
								<div class="red">代理要持续跟进。若已发出，联系渠道和快递追回或改地址</div>
							</div>
							<div v-else-if="scope.row.is_auto_cancel == 1" class="red" style="font-size: 12px;">（系统）</div>
						</template>
					</el-table-column>
					<el-table-column label="下单日期/预发日期/是否准时" align="center" header-align="center" min-width="100px">
						<template slot-scope="scope">
							<div class="datetime-stack">
								<div>{{ formatOrderDate(scope.row.create_time_str) }}</div>
								<div v-if="formatOrderTime(scope.row.create_time_str)" class="datetime-time">{{ formatOrderTime(scope.row.create_time_str) }}</div>
							</div>
							<div class="datetime-stack">
								<div>{{ formatOrderDate(scope.row.prev_time_str) }}</div>
								<div v-if="formatOrderTime(scope.row.prev_time_str)" class="datetime-time">{{ formatOrderTime(scope.row.prev_time_str) }}</div>
							</div>
							<div :style="ontimestr(scope.row.is_on_time_str)">{{scope.row.is_on_time_str}}</div>
						</template>
					</el-table-column>
					<el-table-column label="款号|尺码|数量|实发" align="center" header-align="center" min-width="200px">
						<template slot-scope="scope">
							<div v-for="(v,k) in scope.row.order_detail" :key="k">
								{{v.product_style_number}}|{{v.product_size}}|{{v.num}}|{{v.true_num}}
							</div>
						</template>
					</el-table-column>
					<el-table-column prop="recv_name" label="收货人" align="center" header-align="center" min-width="70px">
					</el-table-column>
					<el-table-column prop="shop_name" label="渠道" align="center" header-align="center" min-width="70px">
					</el-table-column>
					<el-table-column label="渠道折扣" align="center" header-align="center" min-width="60px">
						<template slot-scope="scope">
							<div v-for="(v,k) in scope.row.order_detail" :key="k">
								{{v.true_discount_str}}
							</div>
						</template>
					</el-table-column>
					<el-table-column prop="total_num" label="下单数量" align="center" header-align="center"
						min-width="50px">
					</el-table-column>
					<el-table-column prop="total_fee_for_buyer" label="下单金额" align="center" header-align="center"
						min-width="80px">
					</el-table-column>
					<el-table-column prop="total_fee_true_for_buyer" label="实发金额" align="center" header-align="center"
						min-width="80px">
					</el-table-column>
					<el-table-column prop="total_true_num" label="实发数量" align="center" header-align="center"
						min-width="50px">
					</el-table-column>
					<el-table-column prop="delivery_name" label="快递" align="center" header-align="center"
						min-width="80px">
					</el-table-column>
					<el-table-column label="实发快递" align="center" header-align="center" min-width="80px">
						<template slot-scope="scope">
							<div v-for="(v,k) in scope.row.order_delivery" :key="k">
								{{v.delivery_name}}
							</div>
						</template>
					</el-table-column>
					<el-table-column label="快递单号" align="center" header-align="center" min-width="200px">
						<template slot-scope="scope">
							<div v-for="(v,k) in scope.row.order_delivery" :key="k">
								<span @click="oncopy(v.delivery_num)">
									{{v.delivery_num}} 
									<span class="k" v-if="v.cfrom==1">快</span>
									<span class="j" v-if="v.cfrom==2">聚</span>
								</span>
							</div>
							<div
								v-if="isPddDeliverySyncFailed(scope.row)"
								class="pdd-delivery-sync-error"
							>{{ formatPddDeliverySyncTip(scope.row) }}</div>
						</template>
					</el-table-column>
					<el-table-column label="快递状态" align="center" header-align="center" min-width="80px">
						<template slot-scope="scope">
							<div v-for="(v,k) in scope.row.order_delivery" :key="k">
								<el-popover width="470" trigger="click" @show="ongdd(v.id)" @hide="kdlist = []">
									<div class="kdbox">
										<el-table :data="kdlist" style="width: 100%">
											<el-table-column width="160" prop="time_str" label="时间"></el-table-column>
											<el-table-column width="300" prop="desc" label="地点和跟踪进度"></el-table-column>
										</el-table>
									</div>
									<span slot="reference" :class="oncp(v.delivery_status)">{{v.delivery_status_str}}</span>
								</el-popover>
							</div>
						</template>
					</el-table-column>
					<el-table-column prop="out_trade_no" label="客户单号" align="center" header-align="center"
						min-width="140px">
						<template slot-scope="scope">
							<div>{{scope.row.cfrom_str}}</div>
							<div @click="oncopy(scope.row.out_trade_no)">{{scope.row.out_trade_no}}</div>
						</template>
					</el-table-column>
					<el-table-column prop="buyer_remark" label="备注/备忘/渠道备忘" align="center" header-align="center"
						min-width="150px">
						<template slot-scope="scope">
							<i class="hq el-icon-s-flag" v-if="scope.row.buyer_mark"
								:style="'color:'+onmark(scope.row.buyer_mark)"></i>
							<!-- 备注 -->
							<p>{{scope.row.buyer_remark}}</p>
							<!-- 备忘 -->
							<p :style="'color:'+onmark(scope.row.buyer_mark)">{{scope.row.buyer_memo}}</p>
							<!-- 渠道备忘 -->
							<p v-if="scope.row.seller_memo_show_buyer == 1">{{scope.row.seller_memo}}</p>
						</template>
					</el-table-column>
					<el-table-column label="操作" align="center" header-align="center" fixed="right" width="120px">
						<template slot-scope="scope">
							<div class="operation_i">
								<!-- 通用 -->
								<div>
									<span @click="oninfo(scope.row)">详细</span>
									<span @click="onmemo(scope.row)">备忘</span>
								</div>
								<div>
									<el-dropdown @command="handleCommand($event,scope.row)" placement="bottom">
										<span>标记</span>
										<el-dropdown-menu slot="dropdown">
											<el-dropdown-item :command="0">取消</el-dropdown-item>
											<el-dropdown-item :command="v.id" v-for="(v,k) in appdata.list.mark"
												:key="k"><i :style="'color:'+v.color">{{v.name}}</i></el-dropdown-item>
										</el-dropdown-menu>
									</el-dropdown>

									<span @click="ondetail(scope.row)">重下</span>
								</div>
								<div>
									<span @click="onbuchang(scope.row)">补偿给渠道</span>
									<span @click="onbuchang(scope.row)"
										v-if="scope.row.buchang!='0.00'">(￥{{scope.row.buchang}})</span>
								</div>

								<!-- 未付款 -->
								<div v-if="scope.row.order_status == 0">
									<span @click="onpay(scope.row.trade_no)">付款</span>
									<span @click="ondelet(scope.row.trade_no)">删除</span>
								</div>
								<!-- 已付款 -->
								<div v-if="scope.row.order_status == 1">
									<span @click="oncancel(scope.row.trade_no)">取消</span>
									<span @click="onwork(scope.row)">工单</span>
								</div>
								<!-- 配货中 -->
								<div
									v-if="scope.row.order_status == 3 && scope.row.apply_cancel == 1 && scope.row.agree_send == 0">
									<span @click="onaso(scope.row.trade_no)">同意发货</span>
								</div>
								<div v-if="scope.row.order_status == 3">
									<span @click="handleCancel(scope.row)">申请取消</span>
									<span @click="onwork(scope.row)">工单</span>
								</div>

								<!-- 已发货 -->
								<div v-if="scope.row.order_status == 4">
									<span @click="onservice(scope.row)" v-if="!scope.row.service">售后</span>
									<span @click="onwork(scope.row)">工单</span>
								</div>
								<div v-if="scope.row.order_status == 4">
									<span @click="onquerenshouhuo(scope.row.trade_no)">确认收货</span>
								</div>
								<!-- 售后处理 service 不为空 -->
								<div v-if="scope.row.order_status == 4 && scope.row.service">
									<span @click="onservicedetails(scope.row)">售后处理</span>
								</div>

								<!-- 退货中	已退货 已拒退 已成交-->
								<div
									v-if="(scope.row.order_status == 5 || scope.row.order_status == 6 || scope.row.order_status == 8 || scope.row.order_status == 10) && scope.row.service">
									<span @click="onservicedetails(scope.row)">售后处理</span>
								</div>
								<!-- 已作废 -->
								<div
									v-if="scope.row.order_status == 5 || scope.row.order_status == 6 || scope.row.order_status == 7 || scope.row.order_status == 8 || scope.row.order_status == 10">
									<span @click="onwork(scope.row)">工单</span>
								</div>
							</div>
							<div class="simg">
								<el-tooltip :content="scope.row.shop_qq" placement="bottom" effect="light">
									<img src="../../assets/image/qq.png" @click="oncopy(scope.row.shop_qq)">
								</el-tooltip>
							</div>
						</template>
					</el-table-column>
				</el-table>
			</div>
		</div>

		<div class="pagediv">
			<el-pagination background layout="prev, pager, next, sizes, total" :page-sizes="[20, 30, 50, 100, 200]"
				:current-page.sync="page" :page-size="pageSize" :total="total" v-if="total > 0"
				@current-change="handleCurrentChange" @size-change="handleSizeChange">
			</el-pagination>
		</div>

		<el-dialog title="订单详情" :visible.sync="detailsVisible" width="80%" :before-close="onclose">
			<orderdetails :checkobj="checkedobj" v-if="detailsVisible"></orderdetails>
		</el-dialog>

		<el-dialog title="补偿给渠道" :visible.sync="buchangVisible" width="60%" :before-close="onclose1">
			<el-form :model="buchangForm" :rules="rules" ref="buchangForm" label-width="160px" class="demo-ruleForm"
				v-if="buchangVisible">
				<el-form-item label="业务流水号">
					<div>{{buchang_trade_no}}</div>
				</el-form-item>
				<el-form-item label="渠道">
					<div>{{checkedobj.shop_name}}</div>
				</el-form-item>
				<el-form-item label="补偿给渠道的金额(元)" prop="money">
					<el-input v-model.number="buchangForm.money"></el-input>
					<div class="ts">不能大于订单金额的30%</div>
				</el-form-item>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click="onclose1">取消</el-button>
				<el-button type="primary" @click="onsubbuchang()">确定</el-button>
			</div>
		</el-dialog>

		<el-dialog title="订单备忘" :visible.sync="memoVisible" width="60%" :before-close="onclose2">
			<memo ref="memo" :checkobj="checkedobj" v-if="memoVisible" @ondata="onmemodata"></memo>
			<div slot="footer" class="dialog-footer">
				<el-button @click="onclose2">取消</el-button>
				<el-button type="primary" @click="onsubmemo()">确定</el-button>
			</div>
		</el-dialog>

		<el-dialog title="订单工单申请" :visible.sync="workVisible" width="70%" :before-close="onclose3">
			<workdialog :checkobj="checkedobj" v-if="workVisible" ref="workdialog" @subwork="subwork"></workdialog>
			<div slot="footer" class="dialog-footer">
				<el-button @click="onclose3">取消</el-button>
				<el-button type="primary" @click="onsubwork()">确定</el-button>
			</div>
		</el-dialog>

		<el-dialog title="订单售后申请" :visible.sync="serviceVisible" width="90%" :before-close="onclose4">
			<service :checkobj="checkedobj" v-if="serviceVisible" ref="service" @subservice="subservice"
				@status-abnormal="onStatusAbnormal" :again="again">
			</service>
			<div slot="footer" class="dialog-footer">
				<el-button @click="onclose4">取消</el-button>
				<el-button type="primary" @click="onsubservice()">确定</el-button>
			</div>
		</el-dialog>

		<el-dialog title="订单售后详情" :visible.sync="sdVisible" width="80%" :before-close="onclose5">
			<servicedetails :checkobj="checkedobj" v-if="sdVisible" @odload="onbolist()" @onagain="onagain">
			</servicedetails>
		</el-dialog>
		
		<el-dialog title="订单批量导入" :visible.sync="importVisible" width="600px" :before-close="onclose8">
			
			<div class="uploaddiv">
				<div class="ut">淘宝格式:</div>
				<div class="i_b">
					<el-input v-model="uploadtext1" placeholder="请上传文件" size="small" :readonly="true"></el-input>
					<myupload @resultUrl="onreturnUrl1" :uptype="2"></myupload>
				</div>
				<div class="a" @click="ondownload(1)">下载模版</div>
			</div>
			
			<div class="uploaddiv">
				<div class="ut">非淘宝格式:</div>
				<div class="i_b">
					<el-input v-model="uploadtext2" placeholder="请上传文件" size="small" :readonly="true"></el-input>
					<myupload @resultUrl="onreturnUrl2" :uptype="2"></myupload>
				</div>
				<div class="a" @click="ondownload(2)">下载模版</div>
			</div>
			<div slot="footer" class="dialog-footer">
				<el-button @click="onclose8">取消</el-button>
				<el-button type="primary" @click="onfile()">确定</el-button>
			</div>
		</el-dialog>
	</div>
</template>

<script>
	export default {
		name: 'Order',
		data() {
			return {
				//列表查询
				list: [],
				tablist: [{
					name: 'qb',
					label: '全部',
					num: 0
				}, {
					name: 'wfk',
					label: '未付款',
					num: 0
				}, {
					name: 'phz',
					label: '配货中',
					num: 0
				}, {
					name: 'yfh',
					label: '已发货',
					num: 0
				}, {
					name: 'yqx',
					label: '已取消',
					num: 0
				}],
				filtershow: true,
				page: 1,
				pageSize: 20,
				total: 0,
				kdlist: [],
				formfilter: {
					trade_no: "",
					order_status: "",
					out_trade_no: "",
					style_number: "",
					brand: "",
					cfrom: "",
					buyer_mark: "",
					date_type: "",
					mydate: [],
					btime: "",
					etime: "",
					delivery_num: "",
					recv_name: "",
					buyer_remark: "",
					shop_name: "",
					delivery_id: "",
					buyer_memo: "",
					recv_mobbile: "",
					weifa: 0,
				},
				rules: {
					money: [{
						required: true,
						message: '金额不能为空',
						trigger: 'blur'
					}, {
						type: 'number',
						message: '必须为数字值',
						trigger: 'blur'
					}]
				},

				//选中的对象
				checkedobj: {},

				//详情
				detailsVisible: false,

				// 补偿给渠道
				buchangVisible: false,
				buchang_trade_no: "",
				buchangForm: {
					money: 0
				},

				//订单备忘
				memoVisible: false,

				//工单
				workVisible: false,

				//售后
				serviceVisible: false,
				again: 0,

				//售后详情
				sdVisible: false,
				activeName: "qb",
				
				importVisible: false,
				uploadtext1: "",
				uploadtext2: "",
				uploaddata: {
					file_name: "",
					path: "",
					type: 1
				},
				btnshow: "",
				alldata: []
			}
		},

		inject: ['appdata', 'oncopy', 'formatDate'],

		mounted() {
			this.resizeObserver = new ResizeObserver(entries => {
				for (let entry of entries) {
					const cr = entry.contentRect;
					var num = Number(cr.height) + 30;
					this.$refs.tablediv.style.height = "calc(100% - " + num + "px)";
				}
			});
			this.resizeObserver.observe(this.$refs.filter);
		},

		beforeDestroy() {
			if (this.resizeObserver) {
				this.resizeObserver.disconnect();
			}
		},

		watch: {
			activeName: {
				handler(newVal, oldVal) {
					if (newVal == 'qb') {
						this.formfilter.order_status = "";
					}

					if (newVal == 'wfk') {
						this.formfilter.order_status = 0;
					}

					if (newVal == 'phz') {
						this.formfilter.order_status = 3;
					}

					if (newVal == 'yfh') {
						this.formfilter.order_status = 4;
					}

					if (newVal == 'yqx') {
						this.formfilter.order_status = 2;
					}
					this.formfilter.weifa = 0;
					this.onfilter();
				},
				// immediate: true
			},

			'$route.query': {
				handler(newQuery, oldQuery) {
					if (Object.keys(this.$route.query).length > 0) {
						for (let key in this.$route.query) {
							if (key == 'order_status' || key == 'cfrom') {
								this.formfilter[key] = Number(this.$route.query[key]);
							} else {
								this.formfilter[key] = this.$route.query[key];
							}
						}
					} else {
						var end = new Date();
						var start = new Date();
						start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
						this.formfilter.date_type = 1;
						this.formfilter.mydate = [this.formatDate(start), this.formatDate(end)];
					}
					
					if(this.$route.params.weifa == 1) {
						this.formfilter.weifa = 1;
					}
					this.onbolist();
					this.ontablist();
				},
				deep: true, // 确保对象内部属性的变化也能被检测到
				immediate: true // 组件创建时立即执行一次handler
			}
		},

		methods: {
			getPddDeliverySyncData(row) {
				if (!row) {
					return {}
				}
				if (row.delivery_sync_status != null && row.delivery_sync_status !== '') {
					return row
				}
				return row.pdd_data || {}
			},

			isPddDeliverySyncFailed(row) {
				var data = this.getPddDeliverySyncData(row)
				var status = data.delivery_sync_status
				if (status === 'failed' || status == 2) {
					return true
				}
				var text = data.delivery_sync_status_str != null ? String(data.delivery_sync_status_str) : ''
				return !!(text && text.indexOf('失败') !== -1)
			},

			formatPddDeliverySyncTip(row) {
				var data = this.getPddDeliverySyncData(row)
				var error = data.delivery_sync_error ? String(data.delivery_sync_error) : '同步失败'
				return '同步失败：' + error + '，请尝试前往商家后台发货'
			},

			getOrderDateTimeParts(value) {
				if (value == null || value === '') {
					return { date: '-', time: '' }
				}
				var s = String(value).trim()
				var matched = s.match(/^(\d{4}[-/]\d{1,2}[-/]\d{1,2})\s+(\d{1,2}:\d{2}(?::\d{2})?)/)
				if (matched) {
					return { date: matched[1], time: matched[2] }
				}
				if (/^\d{4}[-/]\d{1,2}[-/]\d{1,2}$/.test(s)) {
					return { date: s, time: '' }
				}
				return { date: s, time: '' }
			},

			formatOrderDate(value) {
				return this.getOrderDateTimeParts(value).date
			},

			formatOrderTime(value) {
				return this.getOrderDateTimeParts(value).time
			},

			// 基础查询
			handleCurrentChange() {
				this.onbolist();
				this.ontablist();
			},

			handleSizeChange(val) {
				this.page = 1;
				this.pageSize = val;
				this.onbolist();
				this.ontablist();
			},

			onfilter() {
				this.page = 1;
				this.onbolist();
				this.ontablist();
			},

			onreset() {
				this.formfilter = {
					trade_no: "",
					out_trade_no: "",
					style_number: "",
					brand: "",
					cfrom: "",
					buyer_mark: "",
					date_type: "",
					mydate: [],
					btime: "",
					etime: "",
					delivery_num: "",
					recv_name: "",
					buyer_remark: "",
					shop_name: "",
					delivery_id: "",
					buyer_memo: "",
					recv_mobbile: "",
					order_status: this.formfilter.order_status,
					weifa: 0,
				};

				if (this.activeName == 'qb') {
					this.formfilter.order_status = "";
				};
				this.page = 1;
				this.onbolist();
				this.ontablist();
			},

			onexport() {
				var obj = JSON.parse(JSON.stringify(this.formfilter));
				obj.btime = obj.mydate[0];
				obj.etime = obj.mydate[1];
				this.$axios.post('api/user/buyer_order_export', obj).then(res => {
					if (res.data.code == 0) {
						this.$message.success('请前往任务中心-导出列表下载');
						this.$parent.oncount();
					} else {
						this.$message.error(res.data.message);
					}
				}).catch(err => {
					console.log(err)
				})
			},

			ontablist() {
				this.$axios.get('api/user/buyer_order_num').then(res => {
					if (res.data.code == 0) {
						this.tablist[1].num = res.data.data.unpay_num;
						this.tablist[2].num = res.data.data.peihuo_num;
						this.tablist[3].num = res.data.data.fahuo_num;
						this.tablist[4].num = res.data.data.cancel_num;
					} else {
						this.$message.error(res.data.message);
					}
				}).catch(err => {
					console.log(err)
				})
			},

			onbolist() {
				var obj = JSON.parse(JSON.stringify(this.formfilter));
				obj.btime = obj.mydate[0];
				obj.etime = obj.mydate[1];
				obj.page = this.page;
				obj.limit = this.pageSize;

				this.$axios.post('api/user/buyer_order_list', obj).then(res => {
					if (res.data.code == 0) {
						this.total = res.data.data.count;
						this.list = res.data.data.list;
						this.btnshow = "";
						if(obj.order_status === 0) {
							this.btnshow = 0;
						}
					} else {
						this.list = []
						this.total = 0
						this.$message.error(res.data.message);
					}
				}).catch(err => {
					console.log(err)
					this.list = []
					this.total = 0
					var data = err && err.response && err.response.data
					this.$message.error((data && (data.message || data.msg)) || '获取订单失败')
				})
			},

			// 详情
			oninfo(obj) {
				this.checkedobj = obj;
				this.detailsVisible = true;
			},

			onclose() {
				this.checkedobj = {};
				this.detailsVisible = false;
			},

			//重下
			ondetail(val) {
				this.$router.push({
					path: '/detail',
					query: {
						id: val.order_detail[0].product_id,
						trade_no: val.trade_no
					}
				})
			},

			//补偿给渠道
			onbuchang(obj) {
				this.checkedobj = obj;
				this.buchangVisible = true;
				this.onbuchang_trade_no();
			},

			onclose1() {
				this.buchangVisible = false;
				this.checkedobj = {};
				this.buchang_trade_no = "";
				this.buchangForm.money = 0;
			},

			onbuchang_trade_no() {
				this.$axios.get('api/user/buchang_trade_no').then(res => {
					if (res.data.code == 0) {
						this.buchang_trade_no = res.data.data.trade_no;
					} else {
						this.$message.error(res.data.message);
					}
				}).catch(err => {
					console.log(err)
				})
			},

			onsubbuchang() {
				this.$refs['buchangForm'].validate((valid) => {
					if (valid) {
						var obj = {
							trade_no: this.checkedobj.trade_no,
							buchang_trade_no: this.buchang_trade_no,
							money: this.buchangForm.money
						}
						this.$axios.post('api/user/buchang', obj).then(res => {
							if (res.data.code == 0) {
								this.$message.success('操作成功');
								this.onclose1();
								this.onbolist();
								this.ontablist();
							} else {
								this.$message.error(res.data.message);
							}
						}).catch(err => {
							console.log(err)
						})
					}
				})
			},

			//备忘
			onmemo(obj) {
				this.checkedobj = obj;
				this.memoVisible = true;
			},

			onclose2() {
				this.checkedobj = {};
				this.memoVisible = false;
			},

			onsubmemo() {
				this.$refs.memo.ondata();
			},

			onmemodata(data) {
				this.$axios.post('api/user/buyer_memo', data).then(res => {
					if (res.data.code == 0) {
						this.$message.success('操作成功');
						this.onclose2();
						this.onbolist();
						this.ontablist();
					} else {
						this.$message.error(res.data.message);
					}
				}).catch(err => {
					console.log(err)
				})
			},

			onmark(id, n) {
				var color = "#000";
				if (this.appdata.list.mark) {
					this.appdata.list.mark.forEach((v, k) => {
						if (v.id == id) {
							color = v.color
						}
					})
				}

				return color;
			},

			handleCommand(val, data) {
				var obj = {
					trade_no: data.trade_no,
					buyer_mark: val,
					buyer_memo: data.buyer_memo,
					buyer_memo_show_seller: data.buyer_memo_show_seller
				};
				this.onmemodata(obj);
			},

			//未付款-付款
			onpay(trade_no) {
				this.$confirm('是否支付该订单?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					var obj = {
						trade_no: trade_no
					}
					this.$axios.post('api/user/pay_order', obj).then(res => {
						if (res.data.code == 0) {
							this.$message.success('付款成功');
							this.onbolist();
							this.ontablist();
						} else {
							this.$message.error(res.data.message);
						}
					}).catch(err => {
						console.log(err)
					})
				}).catch(() => {})
			},

			//未付款-删除
			ondelet(trade_no) {
				this.$confirm('是否删除该条订单, 是否继续?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					var obj = {
						trade_no: trade_no
					}
					this.$axios.post('api/user/delete_order', obj).then(res => {
						if (res.data.code == 0) {
							this.$message.success('删除成功');
							this.onbolist();
							this.ontablist();
						} else {
							this.$message.error(res.data.message);
						}
					}).catch(err => {
						console.log(err)
					})
				}).catch(() => {})
			},

			//已付款-取消
			oncancel(trade_no) {
				this.$confirm('是否取消该条订单, 是否继续?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					var obj = {
						trade_no: trade_no
					}
					this.$axios.post('api/user/cancel_order', obj).then(res => {
						if (res.data.code == 0) {
							this.$message.success('订单取消成功');
							this.onbolist();
							this.ontablist();
						} else {
							this.$message.error(res.data.message);
						}
					}).catch(err => {
						console.log(err)
					})
				}).catch(() => {})
			},

			//配货中-申请取消
			handleCancel(order) {
				if (order.has_jst_config) {
					// 聚水潭渠道：走售后apply
					this.$confirm('是否申请取消该订单?', '提示', {
						confirmButtonText: '确定',
						cancelButtonText: '取消',
						type: 'warning'
					}).then(() => {
						this.$axios.post('/api/orderservice/apply', {
							order_id: order.id,
							buyer_reject_accept: 0,
							extra: [],
							confirm: 1
						}).then(res => {
							if (res.data.code == 0) {
								this.$message.success('申请取消成功');
								this.onbolist();
								this.ontablist();
							} else {
								this.$message.error(res.data.message);
							}
						}).catch(err => {
							console.log(err)
						})
					}).catch(() => {})
				} else {
					// 非聚水潭：走原工单取消
					this.onwork(order)
				}
			},

			//配货中 同意发货

			onaso(trade_no) {
				this.$confirm('是否同意卖家发货, 是否继续?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					var obj = {
						trade_no: trade_no
					}
					this.$axios.post('api/user/agree_send_order', obj).then(res => {
						if (res.data.code == 0) {
							this.$message.success('操作成功');
							this.onbolist();
							this.ontablist();
						} else {
							this.$message.error(res.data.message);
						}
					}).catch(err => {
						console.log(err)
					})
				}).catch(() => {})
			},

			//工单
			onwork(obj) {
				this.checkedobj = obj;
				this.workVisible = true;
			},

			onclose3() {
				this.checkedobj = {};
				this.workVisible = false;
			},

			subwork(res) {
				this.onbolist();
				this.ontablist();
				this.onclose3();
			},

			onsubwork() {
				this.$refs.workdialog.onsub();
			},

			// 售后
			onservice(obj) {
				this.checkedobj = obj;
				this.again = 0;
				this.serviceVisible = true;
			},

			onclose4() {
				var reopen = this.again == 1 && this.checkedobj && this.checkedobj.service;
				this.serviceVisible = false;
				this.again = 0;
				if (reopen) {
					this.sdVisible = true;
				} else {
					this.checkedobj = {};
				}
			},

			onsubservice() {
				this.$refs.service.onsub()
			},

			subservice() {
				var reopen = this.again == 1 && this.checkedobj && this.checkedobj.service;
				this.onbolist();
				this.ontablist();
				this.serviceVisible = false;
				this.again = 0;
				if (reopen) {
					this.sdVisible = true;
				} else {
					this.checkedobj = {};
				}
			},

			onStatusAbnormal() {
				this.serviceVisible = false;
				this.again = 0;
				this.onbolist();
				this.ontablist();
				if (this.checkedobj && this.checkedobj.service) {
					this.sdVisible = true;
				}
			},

			//售后详情
			onservicedetails(obj) {
				this.checkedobj = obj;
				this.sdVisible = true;
			},

			onclose5() {
				this.checkedobj = {};
				this.sdVisible = false;
			},

			//确认收货
			onquerenshouhuo(trade_no) {
				this.$confirm('点击“确认收货”之前，你已确认收到货物?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					var obj = {
						trade_no: trade_no
					}
					this.$axios.post('api/user/querenshouhuo', obj).then(res => {
						if (res.data.code == 0) {
							this.$message.success('确认成功，期待您再次下单');
							this.onbolist();
							this.ontablist();
						} else {
							this.$message.error(res.data.message);
						}
					}).catch(err => {
						console.log(err)
					})
				}).catch(() => {})
			},

			cellClassName({
				row,
				column,
				rowIndex,
				columnIndex
			}) {
				if (columnIndex == 1 || columnIndex == 2) {
					if (row.order_status == 7) {
						return "o_row"
					}

					if (row.order_status == 11) {
						return "y_row"
					}
					var n = row.total_num ? row.total_num:0;
					var t = row.total_true_num ? row.total_true_num:0;
					if (n > t) {
						return "yellor_row"
					}
				}
			},

			ongdd(id) {
				var obj = {};
				obj.id = id;
				this.$axios.post('api/user/get_delivery_detail', obj).then(res => {
					if (res.data.code == 0) {
						this.kdlist = res.data.data.content.reverse();
					} else {
						this.$message.error(res.data.message);
					}
				}).catch(err => {
					console.log(err)
				})
			},

			onagain() {
				this.sdVisible = false;
				this.detailsVisible = false;
				this.again = 1;
				this.serviceVisible = true;
			},
			
			onimport() {
				this.importVisible = true;
			},
			
			onclose8() {
				this.importVisible = false;
				this.uploaddata = {
					file_name: "",
					path: "",
					type: 1
				};
				this.uploadtext1 = "";
				this.uploadtext2 = "";
			},
			
			onreturnUrl1(url, res, file) {
				this.uploaddata.file_name = file.name;
				this.uploaddata.path = res.file;
				this.uploaddata.type = 1;
				this.uploadtext1 = this.uploaddata.file_name;
				this.uploadtext2 = "";
			},
			
			onreturnUrl2(url, res, file){
				this.uploaddata.file_name = file.name;
				this.uploaddata.path = res.file;
				this.uploaddata.type = 2;
				this.uploadtext2 = this.uploaddata.file_name;
				this.uploadtext1 = "";
			},
			
			ondownload(n) {
				var url = "";
				if(n == 1) {
					url ="https://oss.zhidayd.com/%E7%9B%B4%E8%BE%BE%E8%BF%90%E5%8A%A8-%E8%AE%A2%E5%8D%95%E5%AF%BC%E5%85%A5(%E6%B7%98%E5%AE%9D%E6%A0%BC%E5%BC%8F).xls";
				}
				
				if(n == 2) {
					url ="https://oss.zhidayd.com/%E7%9B%B4%E8%BE%BE%E8%BF%90%E5%8A%A8-%E8%AE%A2%E5%8D%95%E5%AF%BC%E5%85%A5(%E9%9D%9E%E6%B7%98%E5%AE%9D%E6%A0%BC%E5%BC%8F).xls";
				}
				window.open(url, '_blank');
			},
			
			onfile() {
				if (!this.uploaddata.file_name || !this.uploaddata.path) {
					this.$message.error("请先上传模版");
					return;
				}
				var obj = {
					path: this.uploaddata.path,
					type: this.uploaddata.type
				};
				this.$axios.post('api/user/import_order', obj).then(res => {
					if (res.data.code == 0) {
						this.$message.success('上传成功，请前往任务中心-导入列表查看状态');
						this.$parent.oncount();
						this.onclose8();
						// this.onbolist();
					} else {
						this.$message.error(res.data.message);
					}
				}).catch(err => {
					console.log(err)
				})
			},
			
			oncp(i) {
				if(i) {
					if(i == 1 || i == 2 || i == 3) {
						return 'cp ysy'
					}
					if(i == 4 || i == 5) {
						return 'cp ysb'
					}
				}else {
					return 'cp'
				}
			},
			
			ontimestr(str) {
				if(str == '准时') {
					return 'color:green';
				}else if(str == '延误'){
					return 'color:red';
				} else {
					return '';
				}
			},
			
			handleSelectionChange(val) {
				this.alldata = val;
			},
			
			onpayAll() {
				var arr = JSON.parse(JSON.stringify(this.alldata));
				var cg = 0;
				if(arr.length > 0) {
					arr.forEach((v,k)=>{
						var obj = {
							trade_no: v.trade_no
						}
						this.$axios.post('api/user/pay_order', obj).then(res => {
							if (res.data.code == 0) {
								cg++;
							} else {
								this.$message.error(res.data.message);
							}
							
							if(cg == arr.length) {
								this.$message.success('付款成功');
								this.onbolist();
								this.ontablist();
							}
							
							
						}).catch(err => {
							console.log(err)
						})
					})
				}else {
					this.$message.warning('必须选择一条数据');
				}
			},
			
			ondeleteAll() {
				var arr = JSON.parse(JSON.stringify(this.alldata));
				var cg = 0;
				if(arr.length > 0) {
					arr.forEach((v,k)=>{
						var obj = {
							trade_no: v.trade_no
						}
						this.$axios.post('api/user/delete_order', obj).then(res => {
							if (res.data.code == 0) {
								cg++;
							} else {
								this.$message.error(res.data.message);
							}
							
							if(cg == arr.length) {
								this.$message.success('删除成功');
								this.onbolist();
								this.ontablist();
							}
							
						}).catch(err => {
							console.log(err)
						})
					})
				}else {
					this.$message.warning('必须选择一条数据');
				}
			}
		}
	}
</script>

<style scoped lang="less">
	.order {
		width: 100%;
		height: calc(100% + 54px);
	}

	.filterty .el-select {
		width: 120px;
	}

	.filterty .el-input {
		width: 120px;
	}

	.filterty .el-date-editor {
		width: 250px;
	}

	.tablediv {
		width: 100%;
	}

	.tablediv-compact {
		/deep/ .el-table td,
		/deep/ .el-table th {
			padding: 2px 0;
		}

		/deep/ .el-table .cell {
			line-height: 16px;
			padding-left: 4px;
			padding-right: 4px;
		}

		/deep/ .el-table .cell > div {
			line-height: 16px;
		}

		/deep/ .el-table .cell > div + div {
			margin-top: 1px;
		}

		/deep/ .operation_i > div + div {
			margin-top: 1px;
		}
	}

	.ts {
		color: #ff4714;
	}

	.hq {
		font-size: 20px;
	}

	.simg {
		width: 100%;
		display: flex;
		justify-content: center;

		img {
			width: 25px;
			height: 25px;
		}
	}

	.red {
		color: red;
	}

	.pdd-delivery-sync-error {
		margin-top: 1px;
		color: #f56c6c;
		font-size: 12px;
		line-height: 1.25;
		text-align: left;
		word-break: break-all;
	}

	.datetime-stack {
		line-height: 16px;
	}

	.datetime-stack .datetime-time {
		color: #606266;
	}

	.kdbox {
		width: 470px;
		height: 400px;
		overflow: auto;
	}

	.cp {
		cursor: pointer;
		text-decoration: underline;
	}

	.tablebox {
		height: calc(100% - 158px);
	}

	.tabdiv {
		width: 100%;
		box-sizing: border-box;
		padding: 0 20px;
	}
	
	.ut {
		width: 75px;
		font-size: 14px;
		color: #303133;
		text-align: right;
	}
	
	.uploaddiv {
		margin-bottom: 20px;
	}
</style>



// WEBPACK FOOTER //
// src/components/buyer/order.vue